/**
 * CD (Consumer Durable) Read Service
 * Migrated from 3in1cms legacy/cdReadApi.ts
 */

import { request } from "../core/request";
import { DEFAULT_CONNECTION_FROM, OPERATION_IDS } from "./constants";
import { createCacheAsync } from "@repo/shared-utils/cache";
// import { dataLayer } from "@repo/analytics/data-layer-utils";
import { generateCTLogData } from "@repo/shared-utils/easyEMIJourney";
import type { ICdReadPayload } from "../types/easyEMIJourneyTypes";
import type { ICdReadResponse } from "../types/cdReadTypes";

/**
 * Read CD (Consumer Durable) data
 * @param reqData - CD read payload with mobile number and ID
 * @returns CD read response with loan data
 */
export const cdRead = async (
  reqData: ICdReadPayload
): Promise<ICdReadResponse | { cDLoanData: null; description: string; statusCode: string }> => {
  try {
    // dataLayer("", generateCTLogData("cdRead", "cdReadAPI Initiated"));

    const response = (await createCacheAsync(
      `${OPERATION_IDS.cdRead}-${reqData.mobileNo}`,
      async () =>
        await request<ICdReadResponse, ICdReadPayload>({
          operationId: OPERATION_IDS.cdRead,
          requestData: reqData,
          connectionFrom: DEFAULT_CONNECTION_FROM,
        })
    )) as ICdReadResponse;

    // dataLayer("", generateCTLogData("cdRead", "cdReadAPI Success"));
    return response;
  } catch (error) {
    // dataLayer("", generateCTLogData("cdRead", "Error fetching cd read data"));
    return {
      cDLoanData: null,
      description: "Error fetching cd read data",
      statusCode: "7002",
    };
  } finally {
    // dataLayer("", generateCTLogData("cdRead", "cdReadAPI Finally Executed"));
  }
};
